import keys from "constants/keys";

/**
 * Handles onKeyPress in one input according to one key.
 * @param {*} onKeyPress Event to be executed
 * @param {*} key Key pressed for event to execute
 */
const handleOnKeyPress = (onKeyPress, key = keys.ENTER) => event => {
  if (onKeyPress && event.key === key) {
    onKeyPress();
  }
};

export default handleOnKeyPress;
